import { Badge, Col, Row } from "react-bootstrap";
import {
  formatRallyDate,
  formatRallyStatus,
  getRallyRouteId,
  getTypeSelectValue,
} from "../../utils/rally.utils";

const statusVariant = {
  active: "success",
  upcoming: "info",
  completed: "secondary",
  cancelled: "danger",
};

const DetailItem = ({ label, children }) => (
  <div className="mb-3">
    <div className="text-muted small mb-1">{label}</div>
    <div>{children ?? "-"}</div>
  </div>
);

const getRouteLabel = (rally) => {
  const route = rally?.route_id || rally?.route;
  if (!route) return "-";
  if (typeof route === "string") return route;
  return route.title || route.name || getRallyRouteId(rally) || "-";
};

const getTypeLabels = (rally) => {
  const raw = Array.isArray(rally?.types)
    ? rally.types
    : rally?.type
      ? [rally.type]
      : [];

  return raw
    .map((type) => {
      if (!type) return "";
      if (typeof type === "string") return type;
      return type.name || type.title || type.key || getTypeSelectValue(type);
    })
    .filter(Boolean);
};

const RallyInfoSection = ({ rally }) => {
  const types = getTypeLabels(rally);

  return (
    <div className="mb-4">
      <div className="d-flex flex-wrap align-items-start justify-content-between gap-3 mb-4">
        <div>
          <h5 className="mb-1">{rally?.name || "Untitled rally"}</h5>
          <div className="text-muted small">
            Edition {rally?.edition_number ?? "-"}
            {rally?._id || rally?.id ? (
              <>
                {" · "}
                ID: <code>{rally._id || rally.id}</code>
              </>
            ) : null}
          </div>
        </div>
        <Badge bg={statusVariant[rally?.status] || "secondary"}>
          {formatRallyStatus(rally?.status)}
        </Badge>
      </div>

      <Row>
        <Col md={6}>
          <DetailItem label="Location">{rally?.location || "-"}</DetailItem>
        </Col>
        <Col md={6}>
          <DetailItem label="Organiser">{rally?.organiser || "-"}</DetailItem>
        </Col>
        <Col md={6}>
          <DetailItem label="Route">{getRouteLabel(rally)}</DetailItem>
        </Col>
        <Col md={6}>
          <DetailItem label="Types">
            {types.length ? (
              <div className="d-flex flex-wrap gap-1">
                {types.map((type) => (
                  <Badge key={type} bg="light" text="dark">
                    {type}
                  </Badge>
                ))}
              </div>
            ) : (
              "-"
            )}
          </DetailItem>
        </Col>
        <Col md={3}>
          <DetailItem label="Rally start">
            {formatRallyDate(rally?.date || rally?.rally_start_date)}
          </DetailItem>
        </Col>
        <Col md={3}>
          <DetailItem label="Rally end">
            {formatRallyDate(rally?.end_date || rally?.rally_end_date)}
          </DetailItem>
        </Col>
        <Col md={3}>
          <DetailItem label="Registration start">
            {formatRallyDate(rally?.registration_start_date)}
          </DetailItem>
        </Col>
        <Col md={3}>
          <DetailItem label="Registration end">
            {formatRallyDate(rally?.registration_end_date)}
          </DetailItem>
        </Col>
        <Col md={12}>
          <DetailItem label="Description">
            {rally?.description || "-"}
          </DetailItem>
        </Col>
      </Row>
    </div>
  );
};

export default RallyInfoSection;
